import gql from "graphql-tag";

export const MY_LEAVE_EVENTS = gql`
  mutation leaveEvents(
    $roleFilters: RoleFilterInput
    $currentDate: Date
    $viewedByAdmin: Boolean
    $role: String
  ) {
    leaveEvents(
      roleFilters: $roleFilters
      currentDate: $currentDate
      viewedByAdmin: $viewedByAdmin
      role: $role
    ) {
      _id
      contract
      start
      end
      state
      workDays
      effectiveWorkDays
      type
      typeName
      leaveType
      title
      sortName
    }
  }
`;
